import { render, staticRenderFns } from "./WarningAlert.vue?vue&type=template&id=c8f1f9e0&scoped=true&"
import script from "./WarningAlert.vue?vue&type=script&lang=js&"
export * from "./WarningAlert.vue?vue&type=script&lang=js&"
import style0 from "./WarningAlert.vue?vue&type=style&index=0&id=c8f1f9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f1f9e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c8f1f9e0', component.options)
    } else {
      api.reload('c8f1f9e0', component.options)
    }
    module.hot.accept("./WarningAlert.vue?vue&type=template&id=c8f1f9e0&scoped=true&", function () {
      api.rerender('c8f1f9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Alerts/WarningAlert.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Alerts/WarningAlert.vue
// module id = mTJv
// module chunks = 0